import { executePut } from "@/server/dvaHelper";
import bus from "@/utils/bus";

export interface IAppRobot {
  robotId: string;
  activeStatus: number | undefined;
  applicationId: string;
  brief?: string | undefined;
  icon?: string;
  version: number;
  name: string;
  lang?: string;
  useDesc?: string;
  builderDeptId?: string;
}
export interface ThirdAppModel {
  name: string;
  adminHomeUrl?: string;
  applicationFlag?: number;
  applicationId: string;
  applicationKey: string;
  applicationSecret?: string;
  authType: 1;
  brief?: string;
  csEmail?: string;
  csJzbAccount?: string;
  csTelephone?: string;
  deeplink?: string;
  deploymentEnvironment: number;
  description?: string;
  developer?: string;
  developmentType?: number;
  favorite?: number;
  homeUrl?: string;
  icon?: string;
  maxVersion?: string;
  minVersion?: string;
  mobileHomeUrl?: string;
  nativeIdentifier?: string;
  omCompany?: string;
  openApiType?: number;
  preview?: string;
  recommended?: number;
  resourceUrl?: string;
  trustedDomains?: string;
  version?: string;
  webviewKernel: number;
  sceneId?: string; // 场景id
  showBadge?: number; // 是否展示角标
  sceneType?: number; // 场景类型
  robots?: IAppRobot[]; // 应用机器人
  builderDeptId?: string; // 应用所属部门id
  builderDeptName?: string; // 应用所属部门名称
}

export interface IShareContent {
  url: string;
  title: string;
  content: string;
  icon?: string;
}

export interface ThirdAppInfo {
  [key: string]: ThirdAppModel;
}

export interface IShareContentMap {
  [key: string]: IShareContent;
}

export interface IDeptAppRobotMap {
  [key: string]: IAppRobot[];
}

export interface ThirdAppMsg {
  [key: string]: Record<string, any>;
}

export interface ThirdAppState {
  thirdAppMap: ThirdAppInfo;
  shareContentMap: IShareContentMap;
  thirdAppMsgCount: ThirdAppMsg;
  thirdAppSceneMap: ThirdAppInfo;
  deptAppRobotMap: IDeptAppRobotMap;
}

export default {
  namespace: "thirdapp",
  state: {
    thirdAppMap: {},
    shareContentMap: {},
    thirdAppMsgCount: {},
    thirdAppSceneMap: {},
    deptAppRobotMap: {}
  },
  reducers: {
    setThirdAppData (
      state: ThirdAppState,
      { payload }: { payload: { appId: string; appData: ThirdAppModel } }
    ) {
      const thirdAppMap = state.thirdAppMap;
      const { appId, appData } = payload;
      thirdAppMap[appId] = appData;
      return { ...state, thirdAppMap };
    },
    setDeptAppRobotMap (
      state: ThirdAppState,
      { payload }: { payload: { thirdAppList: ThirdAppModel[] } }
    ) {
      const deptAppRobotMap: IDeptAppRobotMap = {};
      const { thirdAppList } = payload;
      for (let item of thirdAppList) {
        if (item.builderDeptId && item.robots && item.robots.length > 0) {
          if (!deptAppRobotMap[item.builderDeptId]) {
            deptAppRobotMap[item.builderDeptId] = [];
          }
          deptAppRobotMap[item.builderDeptId] = deptAppRobotMap[item.builderDeptId].concat(item.robots);
        }
      }
      console.log("deptAppRobotMap:", deptAppRobotMap);
      return { ...state, deptAppRobotMap };
    },
    // 237 场景
    setThirdAppSceneData (
      state: ThirdAppState,
      { payload }: { payload: { uuid: string; appData: ThirdAppModel } }
    ) {
      const thirdAppSceneMap = state.thirdAppSceneMap;
      const { uuid, appData } = payload;
      thirdAppSceneMap[uuid] = appData;
      return { ...state, thirdAppSceneMap };
    },
    clearData (state: ThirdAppState) {
      return { ...state, thirdAppMap: {} };
    },
    setShareContentMap (state: ThirdAppState, { payload }: any) {
      return { ...state, ...{ shareContentMap: { ...state.shareContentMap, ...payload } } };
    },
    setThirdAppMsg (state: ThirdAppState, { payload }: { payload: ThirdAppMsg }) {
      let { thirdAppMsgCount } = state;
      thirdAppMsgCount = { ...thirdAppMsgCount, ...payload };
      return { ...state, thirdAppMsgCount };
    },
    updateThirdAppMsg (state: ThirdAppState, { payload }: { payload: any }) {
      const { applicationId, badge } = payload;
      let { thirdAppMsgCount, thirdAppMap, thirdAppSceneMap } = state;
      console.log("tj:>>>>[thirdmapp]>>>updateThirdAppMsg>>", thirdAppMsgCount, thirdAppMap, thirdAppSceneMap);
      let flag = false;
      const keys = Object.keys(thirdAppMsgCount);
      for (const k of keys) {
        if (k.includes(applicationId)) {
          thirdAppMsgCount[k].badge = badge;
          flag = true;
        }
      }
      if (!flag) {
        // 新增角标
        if (thirdAppMap?.[applicationId]) {
          thirdAppMsgCount[applicationId] = {
            badge,
            showBadge: thirdAppMap?.[applicationId]?.showBadge || false
          };
        }
      }
      const values = Object.values(thirdAppSceneMap).filter(
        (i: any) => i?.applicationId === applicationId
      );
      values.forEach((v: any) => {
        thirdAppMsgCount[`${v.applicationId}_${v.sceneId}`] = {
          badge: badge,
          showBadge: v.showBadge
        };
      });
      return { ...state, thirdAppMsgCount: { ...thirdAppMsgCount } };
    },
    clearThirdData (state: ThirdAppState) {
      return {
        ...state,
        thirdAppList: [],
        thirdAppMap: {},
        shareContentMap: {},
        thirdAppMsgCount: {},
        thirdAppSceneMap: {}
      };
    }
  },
  effects: {
    *updatehirdAppList ({ payload }: any, { put }: any) {
      const { thirdAppList } = payload;
      if (!thirdAppList || !thirdAppList.length) {
        return;
      }
      for (let item of thirdAppList) {
        yield executePut(put, "setThirdAppData", {
          appId: item.applicationId,
          appData: item
        });
      }
    },
    *fetchAllAppList ({ payload }: any, { put }: any) {
      const { service, userId, teamId, callback } = payload;
      try {
        const group = yield service.appStoreService.getGroupApplications({
          userId,
          teamId
        });
        if (!group) {
          callback && callback({});
          return;
        }
        const { groupApplications } = group;

        if (groupApplications) {
          const thirdAppList = groupApplications.reduce((a: any, b: any) => {
            return a.concat(b.applications);
          }, []);
          let thirdMap: any = {};
          if (thirdAppList?.length) {
            yield executePut(put, "setDeptAppRobotMap", { thirdAppList });
            for (let item of thirdAppList) {
              yield executePut(put, "setThirdAppData", {
                appId: item.applicationId,
                appData: item
              });
              thirdMap[item.applicationId] = item;
            }
          }
          callback && callback(thirdMap);
        } else {
          callback && callback({});
        }
      } catch (e) {
        callback && callback({});
      }
    },
    *fetchSceneAppList ({ payload }: any, { put }: any) {
      const { service, sceneType, callback } = payload;
      try {
        const group = yield service.appStoreService.getGroupApplicationScenes({
          sceneType
        });
        if (!group) {
          callback && callback({});
          return;
        }
        const { groupApplicationScenes } = group;

        if (groupApplicationScenes) {
          const thirdAppList = groupApplicationScenes.reduce((a: any, b: any) => {
            return a.concat(b.applicationScenes);
          }, []);
          let thirdMap: any = {};
          if (thirdAppList?.length) {
            for (let item of thirdAppList) {
              const uuid = `${item.applicationId}_${item.sceneId}`;
              item.uuid = uuid;
              thirdMap[uuid] = {
                ...item
              };
              yield executePut(put, "setThirdAppSceneData", {
                uuid,
                appData: item
              });
            }
          }
          callback && callback(thirdMap);
        } else {
          callback && callback({});
        }
      } catch (e) {
        callback && callback({});
      }
    }
  },
  subscriptions: {
    "session-event" ({ dispatch }: any, onError: (reason?: any) => void) {
      bus.on("chat_message_multiSync_event:thirdApp", (message) => {
        console.log("tj:>>>>chat_message_multiSync_event:thirdApp>", message);
        if (!message?.applicationId) {
          return;
        }
        const data = {
          applicationId: message?.applicationId,
          badge: message.badgeCount
        };
        bus.emit(`thirdApp:update_${message?.applicationId}`);
        dispatch({ type: "updateThirdAppMsg", payload: data });
      });
    }
  }
};
